export * from "./inputs";
export * from "./strings";
export * from "./dates";
export { default as validations } from "./validations";

export function fetchTotalPages(total, limit = 15) {
  let value = total / limit;
  if (value % 1 !== 0) value = value + 1;

  return Math.trunc(value);
}

export async function validateRecaptcha() {
  try {
    const token = await window?.grecaptcha?.enterprise?.execute(
      process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      {
        action: "submit",
      }
    );

    if (token) return true;
  } catch {
    return false;
  }
}
